import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import XBadge from '../lib/XBadge';
import { getRandomElement } from '../common/Helpers';
import { CAMPAIGN_LOCATION_KEY } from "../common/Constants";
import campaignLogo from '../../assets/images/xrptoolbox-logo.svg';
// import campaignLogo from '../../assets/images/okx.1.svg';
// import campaignLogo from '../../assets/images/moonpay.32.png';
// import campaignLogo from '../../assets/images/icons/fxrp.64.webp';

const excludedCountries = [
  "KP",
  "IR",
];

/**  XRP Toolbox **/
const adVariations = [
  {
    label: <>Try the Toolbox now &rarr;</>,
    title: <>XRP Toolbox - One dashboard for every XRPL account. Balances, payments, trust lines, settings. All in one place and non-custodial.</>,
    href: "https://api.xrpscan.com/api/v1/campaign/xrptoolbox1",
  },
];

/** OKX */
// const adVariations = [
//   {
//     label: <>Join now &rarr;</>,
//     title: <>OKX Crypto Rewards. Step into the world of crypto. Earn $500 in BTC + 3.5% APY on RLUSD</>,
//     href: "https://api.xrpscan.com/api/v1/campaign/okxtext1",
//   },
// ];

/** Flare */
// const adVariations = [
//   {
//     label: <>Get started &rarr;</>,
//     title: <>XRP enters DeFi with FXRP — now live on Flare. Lend, borrow, provide liquidity, and soon, stake.</>,
//     href: "https://api.xrpscan.com/api/v1/campaign/flaretext",
//   },
// ];

const adVariation = getRandomElement(adVariations);

const TextAd = (props) => {
  const [location] = useState(sessionStorage.getItem(CAMPAIGN_LOCATION_KEY));

  if (excludedCountries.includes(location)) {
    return <></>
  }

  return (
    <div>
      <Card className="shadow-sm" border="info">
        <Card.Body>
          <XBadge variant="secondary"><small>SPONSORED:</small></XBadge>
          <Image alt="OKX logo" src={campaignLogo} height="20" className="ml-2 mr-1" />
          <span className="ml-1">{adVariation.title}</span>
          <span className="ml-2"><a href={adVariation.href} target="_blank" rel="noopener noreferrer">{adVariation.label}</a></span>
        </Card.Body>
      </Card>
    </div>
  );
}

TextAd.propTypes = {
  location: PropTypes.string,
}

export default TextAd;
